import { ReflectionDto } from './reflection.dto';

export class Reflection {
    readonly id: string;
    readonly activityId: string;
    readonly activityName: string;
    readonly questionText: string;
    readonly textAnswer: string;
    readonly submittedAt: Date | null;

    constructor(dto: ReflectionDto) {
        this.id = dto.id;
        this.activityId = dto.activityId;
        this.activityName = dto.activityName;
        this.questionText = dto.questionText;
        this.textAnswer = dto.textAnswer ?? '';
        this.submittedAt = dto.submittedAt ? new Date(dto.submittedAt) : null;
    }
}
